import { clientWithAuth } from '@/src/shared/api/axios';

import type {
  ChatAccessDto,
  ChatDto,
  MessageDto,
  MessageListDto,
  MessagesReadDto,
} from './dto';

class ChatsService {
  private readonly BASE_URL = '/api/chats';

  async getAll(search?: string) {
    const response = await clientWithAuth.get<ChatDto[]>(this.BASE_URL, {
      params: search ? { q: search } : undefined,
    });
    return response.data;
  }

  async getMessages(chatId: string, cursor?: string, search?: string) {
    const response = await clientWithAuth.get<MessageListDto>(
      `${this.BASE_URL}/${chatId}/messages`,
      {
        params: {
          ...(cursor ? { cursor } : {}),
          ...(search ? { q: search } : {}),
        },
      },
    );
    return response.data;
  }

  async send(chatId: string, text: string) {
    const response = await clientWithAuth.post<MessageDto>(
      `${this.BASE_URL}/${chatId}/messages`,
      { text },
    );
    return response.data;
  }

  async edit(chatId: string, messageId: string, text: string) {
    const response = await clientWithAuth.patch<MessageDto>(
      `${this.BASE_URL}/${chatId}/messages/${messageId}`,
      { text },
    );
    return response.data;
  }

  async block(chatId: string) {
    const response = await clientWithAuth.post<ChatAccessDto>(
      `${this.BASE_URL}/${chatId}/block`,
    );
    return response.data;
  }

  async unblock(chatId: string) {
    const response = await clientWithAuth.delete<ChatAccessDto>(
      `${this.BASE_URL}/${chatId}/block`,
    );
    return response.data;
  }

  async report(chatId: string, reason: string) {
    await clientWithAuth.post(`${this.BASE_URL}/${chatId}/report`, { reason });
  }

  async markRead(chatId: string) {
    const response = await clientWithAuth.post<MessagesReadDto>(
      `${this.BASE_URL}/${chatId}/read`,
    );
    return response.data;
  }

  async accept(matchId: string) {
    const response = await clientWithAuth.post<{
      chatId: string | null;
      status: ChatDto['matchStatus'];
      studentDecision: ChatDto['myDecision'];
      teacherDecision: ChatDto['myDecision'];
    }>(`/api/matches/${matchId}/accept`);
    return response.data;
  }

  async reject(matchId: string) {
    const response = await clientWithAuth.post<{
      chatId: string | null;
      status: ChatDto['matchStatus'];
      studentDecision: ChatDto['myDecision'];
      teacherDecision: ChatDto['myDecision'];
    }>(`/api/matches/${matchId}/reject`);
    return response.data;
  }
}

export const chatsService = new ChatsService();
